<template>
  <div class="search-form">
    <b-row align-h="between">
      <b-col cols="7">
        <b-form @reset="reset" onsubmit="return false">
          <b-input-group size="sm">
            <b-form-input
              @keyup.enter="query"
              type="search"
              v-model.trim="form.keyword"
              :placeholder="
                this.$l('form_label_search') || '平台编号/平台名称 搜索...'
              "
            />
            <b-input-group-append>
              <b-button-group>
                <b-button-group slot="reference">
                  <b-button
                    variant="link"
                    size="sm"
                    class="search-dropdown-button"
                    squared
                    @click="openAdvqueryDialog"
                  >
                    {{ $l('advanced_search') || '高级搜索' }}
                  </b-button>
                  <b-button variant="primary" size="sm" @click="query">
                    <i class="fa fa-search" />
                  </b-button>
                </b-button-group>
              </b-button-group>
            </b-input-group-append>
            <!-- <b-button
              size="sm"
              class="ml-2"
              variant="outline-success"
              @click="
                $emit('openEditPage', {
                  pageType: 'add',
                  params: {},
                })
              "
              v-if="allow('A')"
            >
              <b-icon-plus></b-icon-plus>
              {{ $l('btn_add') || '新增' }}
            </b-button> -->
          </b-input-group>
        </b-form>
      </b-col>
    </b-row>

    <el-drawer
      :title="$l('advanced_search') || '高级搜索'"
      :visible.sync="advqueryDialogVisible"
      :size="600"
      :show-close="true"
      :wrapper-closable="false"
      :close-on-press-escape="false"
      @close="closeAdvqueryDialog()"
    >
      <div class="drawer-main">
        <el-form ref="form" :model="form" label-width="110px" size="small">
          <el-row :gutter="10">
            <el-col :span="24">
              <el-form-item :label="$l('form_label_platformNo') || '渠道编号'">
                <el-input
                  v-model="form.platformNo"
                  :placeholder="
                    $l('please_label_platformNo') || '请输入渠道编号'
                  "
                  clearable
                  size="small"
                >
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item
                :label="$l('form_label_platformName') || '渠道名称'"
              >
                <el-input
                  v-model="form.platformName"
                  clearable
                  :placeholder="
                    $l('please_label_platformName') || '请输入渠道名称'
                  "
                  size="small"
                >
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <el-col :span="24">
              <el-form-item
                :label="$l('form_label_regionName_country') || '所属国家地区'"
              >
                <dict-select
                  filterable
                  size="small"
                  clearable
                  multiple
                  v-model="form.regionCodeList"
                  :body="regionParams"
                  url="/master/common/dict/biz"
                  :placeholder="
                    $l('please_label_regionName_search') || '请选择所属国家地区'
                  "
                ></dict-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <el-col :span="24">
              <el-form-item
                :label="$l('form_label_platformType') || '渠道类型'"
              >
                <dict-select
                  filterable
                  size="small"
                  clearable
                  multiple
                  v-model="form.platformTypeList"
                  :body="platformTypeParams"
                  url="/sys/common/dict/system"
                  :placeholder="
                    $l('please_label_platformType') || '请选择渠道类型'
                  "
                ></dict-select>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item :label="$l('form_label_CompanyName') || '申请公司'">
                <dict-select
                  size="small"
                  clearable
                  filterable
                  multiple
                  v-model="form.ecomCompanyCodeList"
                  url="/ecom/ecomCompany/select"
                  :placeholder="
                    $l('please_label_ecomCompany') || '请选择申请公司'
                  "
                ></dict-select>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item :label="$l('form_label_custCode') || '所属客户'">
                <dict-select
                  v-model="form.custCodeList"
                  url="/master/common/dict/customerSelect"
                  :placeholder="$l('please_label_cust') || '请选择所属客户...'"
                  size="small"
                  clearable
                  multiple
                  filterable
                ></dict-select>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item
                :label="$l('form_label_ecomPmaCode_search') || '电商平台账户'"
                prop="ecomPmaCode"
              >
                <dict-select
                  filterable
                  size="small"
                  clearable
                  multiple
                  v-model="form.ecomPmaCodeList"
                  :body="ecomPmaCodeParams"
                  url="/ecom/evg/platform/select/account"
                  :placeholder="
                    $l('please_label_ecomPma_search') || '请选择电商平台账户'
                  "
                ></dict-select>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item
                :label="
                  $l('form_label_warehousePmaCode_search') || '仓库平台账户'
                "
                prop="warehousePmaCode"
              >
                <dict-select
                  filterable
                  size="small"
                  clearable
                  multiple
                  v-model="form.warehousePmaCodeList"
                  :body="warehousePmaCodeParams"
                  url="/ecom/evg/platform/select/account"
                  :placeholder="
                    $l('please_label_warehousePma_search') ||
                      '请选择仓库平台账户'
                  "
                ></dict-select>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item
                :label="$l('form_label_shippingMethod_search') || '发运方式'"
                prop="shippingMethod"
              >
                <el-input
                  v-model="form.shippingMethod"
                  clearable
                  size="small"
                  :placeholder="
                    $l('please_label_shippingMethod_search') || '请输入发运方式'
                  "
                  maxlength="100"
                >
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item
                :label="$l('form_label_warehouseCode_search') || '仓库代码'"
                prop="warehouseCode"
              >
                <el-input
                  v-model="form.warehouseCode"
                  clearable
                  size="small"
                  :placeholder="
                    $l('please_label_warehouseCode_search') || '请输入仓库代码'
                  "
                  maxlength="100"
                >
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item
                :label="$l('form_label_shipNode_search') || '分销商ID'"
                prop="shipNode"
              >
                <el-input
                  v-model="form.shipNode"
                  clearable
                  size="small"
                  :placeholder="$l('please_label_shipNode_search') || '请输入分销商ID'"
                  maxlength="100"
                >
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <el-col :span="24">
              <el-row>
                <el-form-item
                  :label="$l('form_lable_create_date') || '创建时间'"
                >
                  <el-col :span="11">
                    <el-date-picker
                      v-model="form.beginCreateDate"
                      type="date"
                      size="small"
                      value-format="yyyy-MM-dd"
                      :placeholder="
                        $l('please_label_create_date') || '请选择创建时间'
                      "
                      style="width: 100%"
                    >
                    </el-date-picker>
                  </el-col>
                  <el-col class="line" :span="2">-</el-col>
                  <el-col :span="11">
                    <el-date-picker
                      v-model="form.endCreateDate"
                      type="date"
                      size="small"
                      value-format="yyyy-MM-dd"
                      :placeholder="
                        $l('please_label_create_date') || '请选择创建时间'
                      "
                      style="width: 100%"
                    >
                    </el-date-picker>
                  </el-col>
                </el-form-item>
              </el-row>
            </el-col>
            <el-col :span="24">
              <el-row>
                <el-form-item
                  :label="$l('form_label_modifyDate') || '修改时间'"
                >
                  <el-col :span="11">
                    <el-date-picker
                      v-model="form.beginModifyDate"
                      type="date"
                      size="small"
                      value-format="yyyy-MM-dd"
                      :placeholder="
                        $l('please_label_modification_date') || '请选择修改时间'
                      "
                      style="width: 100%"
                    >
                    </el-date-picker>
                  </el-col>
                  <el-col class="line" :span="2">-</el-col>
                  <el-col :span="11">
                    <el-date-picker
                      v-model="form.endModifyDate"
                      type="date"
                      size="small"
                      value-format="yyyy-MM-dd"
                      :placeholder="
                        $l('please_label_modification_date') || '请选择修改时间'
                      "
                      style="width: 100%"
                    >
                    </el-date-picker>
                  </el-col>
                </el-form-item>
              </el-row>
            </el-col>
            <el-col :span="24">
              <el-form-item :label="$l('form_label_createBy') || '创建人'">
                <dict-select
                  v-model="form.listCreateBy"
                  url="/master/common/dict/baseUserSelect"
                  :placeholder="$l('please_label_create') || '请选择创建人...'"
                  filterable
                  clearable
                  multiple
                />
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item :label="$l('form_label_modifyBy') || '修改人'">
                <dict-select
                  v-model="form.listModifyBy"
                  url="/master/common/dict/baseUserSelect"
                  :placeholder="$l('please_label_Modify') || '请选择修改人...'"
                  filterable
                  clearable
                  multiple
                />
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <span class="drawer-footer">
        <el-button size="small" @click="closeAdvqueryDialog">{{
          $l('INDEX.btn_cancel_query') || '取消查询'
        }}</el-button>
        <el-button size="small" type="warning" @click="reset">{{
          $l('INDEX.btn_reset_filter') || '重置条件'
        }}</el-button>
        <el-button size="small" type="primary" @click="advquery">{{
          $l('INDEX.btn_data_retrieval') || '数据检索'
        }}</el-button>
      </span>
    </el-drawer>
  </div>
</template>

<script>
// 初始表单
const initForm = {
  keyword: '',
  platformStatusList: ['S'],
}
export default {
  data() {
    return {
      advqueryDialogVisible: false,
      form: { ...initForm },
      platformTypeParams: { dictType: 'platformType' },
      regionParams: { dictType: 'region' },
      ecomPmaCodeParams: { platformType: 'E' },
      warehousePmaCodeParams: { platformType: 'W' },
    }
  },

  mounted() {
    this.query()
  },
  methods: {
    fromLoad(val) {
      this.$emit(val)
    },
    // 初始查询
    query({ isReset = true } = {}) {
      if (isReset) {
        this.$emit('reset')
      }
      this.$emit('query', this.form)
    },
    // 高级查询
    advquery() {
      this.form.keyword = ''
      this.query()
      this.closeAdvqueryDialog()
    },
    // 重置查询条件 - 高级查询
    reset() {
      this.form = { ...initForm }
    },
    // 打开高级查询
    openAdvqueryDialog() {
      this.advqueryDialogVisible = true
    },
    // 关闭高级查询
    closeAdvqueryDialog() {
      this.advqueryDialogVisible = false
    },
  },
}
</script>
<style lang="scss" scoped>
.el-form-item {
  margin-bottom: 0px;
}
.line {
  text-align: center;
}
.drawer-main {
  padding: 0 20px 20px;
}
.drawer-footer {
  padding: 10px 20px 30px;
  display: flex;
  justify-content: flex-end;
}
</style>
